import { createAsyncThunk } from "@reduxjs/toolkit";
import { ForceUpdateActions } from "./ForceUpdateSlice";

export const setForceUpdateConfig = createAsyncThunk(
    "setForceUpdateConfig", async ({ appVersion, isUpdateRequired }: { appVersion: string, isUpdateRequired: boolean } , { dispatch, getState }) => {
        try {
            await dispatch(ForceUpdateActions.setForceUpdateOptions({
                appVersion,
                isForceUpdateRequired: isUpdateRequired
            }))
        } catch (error) {
            await dispatch(ForceUpdateActions.resetForcedUpdateOptions());
            console.log("error in setting forced update options: ", error, (error as any).response);
        }
    }
);